import React from 'react';
import './BlogPostList.css'; // Add this import

const BlogPostList = () => {
  return (
    <div className="blog-post-list">
      <div className="coming-soon-banner">
        <h2>Blog Posts Coming Soon</h2>
        <p>We're working on exciting content. Stay tuned!</p>
      </div>
    </div>
  );
};

export default BlogPostList;
